import React, { useMemo } from 'react';

import { EditableSession } from 'types/event.types';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  TabsBadge
} from '@epoch-ui/components/Tabs/tabs';

import { SessionsTable } from '../components/SessionsTable';

interface SessionsSectionProps {
  sessions: EditableSession[];
}

const SessionsSection: React.FC<SessionsSectionProps> = ({ sessions }) => {
  const upcomingSessions = useMemo(() => {
    return sessions.filter((session) => !session.hasEnded);
  }, [sessions]);

  const pastSessions = useMemo(() => {
    return sessions.filter((session) => session.hasEnded);
  }, [sessions]);

  return (
    <div>
      <h2 className="tw-m-0 tw-mb-4 tw-text-xl tw-font-medium tw-leading-7">Sessions</h2>

      <Tabs defaultValue="all">
        <TabsList>
          <TabsTrigger value="all">
            All <TabsBadge>{sessions.length}</TabsBadge>
          </TabsTrigger>
          <TabsTrigger value="upcoming">
            Upcoming <TabsBadge>{upcomingSessions.length}</TabsBadge>
          </TabsTrigger>
          <TabsTrigger value="past">
            Past <TabsBadge>{pastSessions.length}</TabsBadge>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="tw-pt-2">
          <SessionsTable sessions={sessions} emptyMessage="No sessions for this event." />
        </TabsContent>
        <TabsContent value="upcoming" className="tw-pt-2">
          <SessionsTable
            sessions={upcomingSessions}
            emptyMessage="No upcoming sessions for this event."
          />
        </TabsContent>
        <TabsContent value="past" className="tw-pt-2">
          <SessionsTable sessions={pastSessions} emptyMessage="No past sessions for this event." />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export { SessionsSection };
